import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "convex/react";
import { useAuth } from "@workos-inc/authkit-react";
import { api } from "../../convex/_generated/api";
import { hasWorkOsConfig } from "../lib/config";
import { beginWorkOsSignIn } from "../lib/workos-sign-in";
import { storeInviteToken } from "../lib/inviteToken";

export function InvitePage() {
  const { token = "" } = useParams();
  const invite = useQuery(api.organizations.getInviteByToken, token ? { token } : "skip");
  const { user, signIn, isLoading } = useAuth();
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    if (token) storeInviteToken(token);
  }, [token]);

  useEffect(() => {
    if (!isLoading && user) {
      window.location.replace("/");
    }
  }, [isLoading, user]);

  if (invite === undefined) {
    return (
      <main className="main">
        <p className="muted">Loading invite…</p>
      </main>
    );
  }

  if (!invite || invite.status !== "open") {
    return (
      <main className="main">
        <section className="setup-gate">
          <h1>Invite unavailable</h1>
          <p>
            {invite?.status === "accepted"
              ? "This invite was already accepted. Sign in with Google to continue."
              : "This invite link is invalid or expired. Ask an admin to send a new one."}
          </p>
          <Link to="/" className="btn primary">
            Go to Track
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="main">
      <section className="setup-gate">
        <h1>You're invited to {invite.orgName}</h1>
        <p>
          Sign in with Google as <strong>{invite.email}</strong> to join as{" "}
          <span className="role-pill">{invite.role}</span>.
        </p>
        {!hasWorkOsConfig ? (
          <p className="error">WorkOS is not configured in this environment.</p>
        ) : (
          <button
            type="button"
            className="btn primary"
            disabled={signingIn || isLoading}
            onClick={() => {
              setSigningIn(true);
              storeInviteToken(token);
              beginWorkOsSignIn(signIn);
              setSigningIn(false);
            }}
          >
            {signingIn ? "Redirecting…" : "Sign in with Google"}
          </button>
        )}
        <p className="muted tiny">
          Use the Google account for {invite.email}. Other emails cannot accept this invite.
        </p>
      </section>
    </main>
  );
}
